import { Platform } from "react-native";
import InlineLinkText from "src/components/InlineLinkText";
import { paddingSmall } from "src/styles/spacing";
import { TextProps } from "src/swsh-native";
import {
	CommentBubbleHorizontalPadding,
	CommentBubbleLargeRadius,
	CommentBubbleVerticalPadding,
} from "../constants";
import parseCommentBubbleRadiusOverrides from "../helpers/parseCommentBubbleRadiusOverrides";
import { CommentAttachmentType, CommentBubbleProps } from "../types";

/**
 * iOS clips emojis
 *
 * See ENG-2901
 */
const iOSWorkaroundStyle: TextProps["style"] | undefined =
	Platform.OS === "ios"
		? {
				marginVertical: -paddingSmall,
				paddingVertical: paddingSmall,
			}
		: undefined;

const CommentBubbleText = ({
	content,
	backgroundColor,
	position,
	sender,
	isSending,
	contextMenuAttachment,
}: {
	content: string;
	backgroundColor: string;
	position: NonNullable<CommentBubbleProps["position"]>;
	sender: NonNullable<CommentBubbleProps["sender"]>;
	isSending: boolean;
	contextMenuAttachment?: CommentAttachmentType.ContextMenu;
}) => {
	const CommentBubbleTextNode = (
		<InlineLinkText
			containerStyle={[
				{
					borderRadius: CommentBubbleLargeRadius,
					backgroundColor,
					paddingHorizontal: CommentBubbleHorizontalPadding,
					paddingVertical: CommentBubbleVerticalPadding,
				},
				parseCommentBubbleRadiusOverrides({
					position,
					sender,
				}),
			]}
			textProps={{
				color: isSending ? "TextLight" : "Text",
				style: iOSWorkaroundStyle,
			}}
			linkTextProps={{
				color: isSending ? "TextLight" : "Text",
				semibold: true,
				style: iOSWorkaroundStyle,
			}}
		>
			{content}
		</InlineLinkText>
	);

	if (contextMenuAttachment) {
		return contextMenuAttachment.renderContextMenu({
			children: CommentBubbleTextNode,
		});
	}
	return CommentBubbleTextNode;
};
export default CommentBubbleText;
